import React from 'react';
import { Box, Typography } from "@mui/material"
import Button from "@mui/material/Button"
interface ZoomControlsProps {
    setViewPosition: React.Dispatch<React.SetStateAction<{
        latitude: number;
        longitude: number;
        zoom: number;
    }>>
}

const boutonStyle= {
    maxWidth: '30px',
    maxHeight: '30px',
    minWidth: '30px',
    minHeight: '30px',
    borderRadius: '0px',
}

const ZoomControls: React.FC<ZoomControlsProps> = ({ setViewPosition }) => {


    const handleZoomIn = () => {
        setViewPosition((prevView) => ({ ...prevView, zoom: prevView.zoom + 1 }));
    };

    const handleZoomOut = () => {
        setViewPosition((prevView) => ({ ...prevView, zoom: prevView.zoom - 1 }));
    };


    return (
        <Box sx={{position: 'absolute',  top: '2%', left: '2%'}}>
            <Box>
                <Button style={boutonStyle} sx={{backgroundColor: 'white'}} onClick={handleZoomIn}>
                    <Typography variant='title'>+</Typography>
                </Button>
            </Box>
            <Box>
                <Button style={boutonStyle} sx={{backgroundColor: 'white'}} onClick={handleZoomOut}>
                    <Typography variant='title'>-</Typography>
                </Button>
            </Box>
        </Box>
    );
};

export default ZoomControls;